import { useState } from 'react';
import { LoadingScreen } from '../LoadingScreen';
import { setAuthUser } from '../../../../redux/slices/AuthUser';
import { useDispatch } from 'react-redux';
import axiosInstance from '../../../../axios/axiosInstance';
import { decodeToken } from '../../../../helper/decodeToken';
// ESM replacement — the CJS @greatsumini/react-facebook-login package is
// double-wrapped by Vite 8 / Rolldown's CJS interop, causing React error #130.
import FacebookLogin from './FacebookLoginESM';
import useNavigateBasedOnPath from '../../helper/checkPrevPath';
import { useShowAlert } from '../../../../hooks/useShowAlert';
import { Button } from '@mui/material';
const FacebookLoginButton = ({
  children = 'Login with Facebook',
  buttonSx = null,
  endIcon = null,
  startIcon = null,
  variant = 'contained',
  onSuccess,
}) => {
  const { showAlert } = useShowAlert();
  const dispatch = useDispatch();
  const navigateBasedOnPath = useNavigateBasedOnPath();
  const APPID = import.meta.env.VITE_VERCEL_APP_ID_FACEBOOK
  const [accessToken, setAccessToken] = useState('');
  if (!APPID) {
    return (
      <Button
        variant={variant}
        startIcon={startIcon}
        endIcon={endIcon}
        disabled
        sx={{
          ...(buttonSx || {
            height: '50px',
            width: '244px',
            borderRadius: '5px',
            mt: '10px',
            mb: '10px',
          }),
          opacity: 0.65,
          '&.Mui-disabled': {
            color: buttonSx?.color || 'inherit',
            borderColor: buttonSx?.borderColor || undefined,
            backgroundColor: buttonSx?.backgroundColor || undefined,
          },
        }}
      >
        {children}
      </Button>
    );
  }
  // handle response from facebook and send token to server
  const responseFacebook = (response) => {
    setAccessToken(response.accessToken);
    // send token to server
    axiosInstance.post('/user/auth/facebook', { accessToken: response.accessToken }).then(async (res) => {
      const token = res.data?.token;
      const { id, exp } = await decodeToken(token);
      if (!token || !id || !exp) {
        throw new Error('The server returned an invalid login session');
      }
      localStorage.setItem('token', token);
      dispatch(setAuthUser({ user: res.data?.user || null, exp: exp, id: id })) // set user to redux
      setAccessToken('');
      onSuccess?.(res.data?.user || null);
      navigateBasedOnPath();
    }).catch((err) => {
      showAlert("error", err.response?.data?.error || err.response?.data?.message || err.message); // show error message to user
      setAccessToken(''); // reset access token to hide loading screen
    });
  }
  const facebookProps = {
    appId: APPID,
    onSuccess: responseFacebook,
    onFail: (err) => {
      showAlert("error", err.message); // show error message to user
      setAccessToken('');// reset access token to hide loading screen
    },
  };

  return (

    <>
      {buttonSx ? (
        <FacebookLogin
          {...facebookProps}
          render={({ onClick }) => (
            <Button
              variant={variant}
              startIcon={startIcon}
              endIcon={endIcon}
              onClick={onClick}
              sx={buttonSx}
            >
              {children}
            </Button>
          )}
        />
      ) : (
        <FacebookLogin
          {...facebookProps}
          style={{
            height: '50px',
            background: 'blue',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.1rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '10px',
            marginBottom: '10px',
            width: "244px",
            borderRadius: "5px",
          }}
        />
      )}


      <LoadingScreen loadingState={!!accessToken} />
    </>

  );
};

export default FacebookLoginButton;
